(function() {
  function fitLine(parent, dotSelector, lineSelector) {
    var dots = parent.querySelectorAll(dotSelector);
    var line = parent.querySelector(lineSelector);
    if (dots.length < 2 || !line) return;

    var parentRect = parent.getBoundingClientRect();
    var firstDot = dots[0].getBoundingClientRect();
    var lastDot = dots[dots.length - 1].getBoundingClientRect();

    var firstCenter = firstDot.top + firstDot.height / 2 - parentRect.top;
    var lastCenter = lastDot.top + lastDot.height / 2 - parentRect.top;

    parent.style.setProperty('--line-top', firstCenter + 'px');
    parent.style.setProperty('--line-height', (lastCenter - firstCenter) + 'px');
  }

  function fitAll() {
    document.querySelectorAll('.komfy-timeline').forEach(function(t) {
      fitLine(t, '.komfy-timeline-step__dot', '.komfy-timeline__line');
    });
    document.querySelectorAll('.komfy-roadmap').forEach(function(r) {
      fitLine(r, '.komfy-roadmap__dot', '.komfy-roadmap__line');
    });
  }

  fitAll();
  window.addEventListener('resize', fitAll, { passive: true });
})();
